import { render, staticRenderFns } from "./UserLevel.vue?vue&type=template&id=fa6b2e56&scoped=true&"
import script from "./UserLevel.vue?vue&type=script&lang=js&"
export * from "./UserLevel.vue?vue&type=script&lang=js&"
import style0 from "./UserLevel.vue?vue&type=style&index=0&id=fa6b2e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6b2e56",
  null
  
)

export default component.exports